import { Navigate } from "react-router";
import { STOREFRONT_LINKS } from "../../../constants/routes";

export const StorefrontLinksV2Redirect = () => {
  return <Navigate to={STOREFRONT_LINKS} />;
};
